/**
 * created by lei lei on 2020/6/5
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BraftEditor from 'braft-editor'
import 'braft-editor/dist/index.css'
import {ContentUtils} from 'braft-utils'
import {Input, Button} from 'antd';
import {ImageUtils} from 'braft-finder'
import {uuid} from "../../utils";
import $ from  'jquery';

export default class Editor extends Component {
    static defaultProps = {
        customHeight: 500
    }
    static propTypes = {
        callBackeditorContent: PropTypes.func.isRequired,//回调编辑器返回的内容，属于必传项，必须传入
        customHeight: PropTypes.number,//编辑器的高度，自定义默认不传是500
    }
    state = {
        editorState: BraftEditor.createEditorState(this.props.content),
        linkContent: '',
    }


    handleChange = (editorState) => {
        this.props.callBackeditorContent && this.props.callBackeditorContent(editorState.toHTML())
        this.setState({editorState})

    }

    componentWillReceiveProps(nextProps, nextContext) {
        let content = nextProps.content
        if (nextProps.isUpDate) {
            this.setState({
                editorState: BraftEditor.createEditorState(content)
            })
        }

    }

    componentDidMount(prevProps, prevState, snapshot){
        //屏蔽h3，h4，h5，h6样式
        $(".dropdown-content-inner").eq(1).find('li').eq(2).hide()
        $(".dropdown-content-inner").eq(1).find('li').eq(3).hide()
        $(".dropdown-content-inner").eq(1).find('li').eq(4).hide()
        $(".dropdown-content-inner").eq(1).find('li').eq(5).hide()
    }


    render() {

        //微博使用的样式
        const controls = ['undo', 'redo', 'separator',
            'separator',
            'text-color', 'bold', 'italic', 'underline', 'strike-through', 'separator',
            'remove-styles', 'separator', 'text-align', 'separator',
            'headings', 'list-ul', 'list-ol', 'blockquote',  'separator',
            'separator', 'hr', 'separator',
            'media',
            'separator',
            'clear']

        //对齐方式
        const textAligns = ['left', 'center', 'right']

        const fontFamily = [{
            name: '微软雅黑',
            family: 'MicrosoftYaHei'
        }, {
            name: 'Araial',
            family: 'Arial, Helvetica, sans-serif'
        }, {
            name: 'Georgia',
            family: 'Georgia, serif'
        }, {
            name: 'Impact',
            family: 'Impact, serif'
        }, {
            name: 'Monospace',
            family: '"Courier New", Courier, monospace'
        }, {
            name: 'Tahoma',
            family: 'tahoma, arial, "Hiragino Sans GB", 宋体, sans-serif'
        }];
        //自定义编辑器功能
        const extendControls = [
            'separator',
            {
                key: 'my-dropdown',
                type: 'dropdown',
                title: 'link', // 指定鼠标悬停提示文案
                className: 'my-dropdown', // 指定下拉组件容器的样式名
                html: null, // 指定在按钮中渲染的html字符串
                text: 'link', // 指定按钮文字，此处可传入jsx，若已指定html，则text不会显示
                showArrow: true, // 指定是否显示下拉组件顶部的小三角形
                arrowActive: false, // 指定是否高亮下拉组件顶部的小三角形
                autoHide: true, // 指定是否在失去焦点时自动隐藏下拉组件
                component: <div style={{padding: 5, display: 'flex', width: 350}}>
                    <Input placeholder="请输入插入链接" value={this.state.linkContent} style={{width: 300}}
                           onChange={(e) => {
                               console.log(e)
                               this.setState({
                                   linkContent: e.target.value
                               })
                           }
                           }
                    /> <Button type="primary" style={{width: 50}} onClick={() => {
                    this.setState({
                        linkContent: '',
                        editorState: ContentUtils.insertHTML(this.state.editorState, '<a href="' + this.state.linkContent + '"><span color="#ff0000;">' + this.state.linkContent + '</span></a>')
                    })
                }}>确定</Button>
                </div>, // 指定在下拉组件中显示的内容组件
            }
        ];

        //视频上传到自己服务器勿动
        const uploadFn = (param) => {

            const serverURL = '/cm-sites-pms/ueditor/control?action=uploadimage';
            const xhr = new XMLHttpRequest;
            const fd = new FormData();

            // libraryId可用于通过mediaLibrary示例来操作对应的媒体内容
           // console.log(param.libraryId)

            const successFn = (response) => {
                //console.log(response)
                // 假设服务端直接返回文件上传后的地址
                // 上传成功后调用param.success并传入上传后的文件地址
                // console.log(param);
                console.log(xhr);//图片返回的结果
                let Data = JSON.parse(xhr.response);//图片数据信息
                console.log(Data);
                param.success({
                    url: Data.url,
                    meta: {
                        id: Data.storageFile._id,
                        title: Data.title,
                        alt: Data.title,
                        loop: true, // 指定音视频是否循环播放
                        autoPlay: true, // 指定音视频是否自动播放
                        controls: true, // 指定音视频是否显示控制栏
                        poster: '', // 指定视频播放器的封面
                    }
                })
            };

            const progressFn = (event) => {
                // 上传进度发生变化时调用param.progress
                param.progress(event.loaded / event.total * 100)
            };

            const errorFn = (response) => {
                // 上传发生错误时调用param.error
                param.error({
                    msg: 'unable to upload.'
                })
            };

            xhr.upload.addEventListener("progress", progressFn, false);
            xhr.addEventListener("load", successFn, false);
            xhr.addEventListener("error", errorFn, false);
            xhr.addEventListener("abort", errorFn, false);

            fd.append('file', param.file)
            xhr.open('POST', serverURL, true)
            xhr.send(fd)

        }


        return (
            <div>
                <div className="editor-wrapper">
                    <BraftEditor
                        value={this.state.editorState}
                        fontFamilies={fontFamily}
                        ref={(instance) => this.editorInstance = instance}
                        media={{
                            allowPasteImage: true,
                            image: true, // 开启图片插入功能
                            video: true, // 开启视频插入功能
                            audio: true, // 开启音频插入功能
                            uploadFn: uploadFn,
                            externalMedias:{
                                image: false,
                                audio: false,
                                video: false,
                                embed: false
                            }
                        }}
                        contentStyle={{border: '1px solid #ececec', height: this.props.customHeight}}
                        onChange={this.handleChange}
                        controls={controls}
                        extendControls={extendControls}
                        textAligns={textAligns}
                    />
                </div>
            </div>
        )

    }


}